"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SIGN_OUT_DEVICE_MUTATION = "\nmutation SignOutDevices($appId: AppId!, $deviceTypes: [SignOutDeviceType!]) {\n  signOutDevices(appId: $appId, deviceTypes: $deviceTypes) {\n    id\n    lastSeen\n    deviceType\n    isCurrent\n    deviceDescription\n    sessionId\n  }\n}\n";
exports.default = SIGN_OUT_DEVICE_MUTATION;
//# sourceMappingURL=signOutDevice.js.map